// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import eventPriorityTranslations from 'infras/i18n/locales/event_priority.json';
import eventTagTranslations from 'infras/i18n/locales/event_tag.json';
import Emoji from 'presentations/views/components/atoms/Emoji';

import styled from '@emotion/styled';
import { spacing, fontSize } from 'presentations/views/styles';
import { EventDetailItem, EventListItem } from 'presentations/api/schema/event';
import {
  getPriorityOptions,
  getTagOptions,
} from 'presentations/views/helpers/event';
import EventMetaTag from 'presentations/views/components/molecules/EventMetaTag';
import { gray01, gray04 } from 'presentations/views/styles/color';

interface Props {
  event: EventListItem | EventDetailItem;
  projectName?: string;
  projectIcon?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent([
    translations,
    eventPriorityTranslations,
    eventTagTranslations,
  ]);
  const priorityOptions = getPriorityOptions(t);
  const isPriotity = typeof props.event.priority === 'number';
  return (
    <MetaList>
      {isPriotity && (
        <MetaTagItem>
          <EventMetaTag
            iconName="flag-triangle"
            options={priorityOptions}
            isStatic
            selectedValue={props.event.priority}
            tooltipText={t('priority')}
          />
        </MetaTagItem>
      )}
      {props.projectName && isPriotity && <Border />}
      {props.projectName && (
        <MetaTagItem>
          <Emoji name={props.projectIcon || 'flag'} size={15} />
          <ProjectName>{props.projectName}</ProjectName>
        </MetaTagItem>
      )}
    </MetaList>
  );
}

const MetaList = styled.div`
  display: flex;
  align-items: center;
`;
const Border = styled.div`
  width: 1px;
  height: 16px;
  background-color: ${gray04};
  margin: 0 ${spacing(8)};
`;
const MetaTagItem = styled.div`
  margin-right: ${spacing(8)};
  display: inline-flex;
  align-items: center;
`;

const ProjectName = styled.span`
  margin-left: ${spacing(4)};
  font-size: ${fontSize(13)};
  color: ${gray01};
`;
